module.exports = __webpack_public_path__ + "img/default.4d4009e2.jpg";